import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaCheck } from 'react-icons/fa';
import './LangSwitcher.css';

const ALL_LANGUAGES = [
  { code: 'sk', label: 'Slovenčina', short: 'SK' },
  { code: 'en', label: 'English',    short: 'EN' },
  { code: 'tr', label: 'Türkçe',     short: 'TR' },
];

/**
 * Reusable language dropdown.
 * `variant`:  "light" (admin) | "dark" (over hero)
 * `languages`: array of language codes to show — defaults to all 3
 */
const LangSwitcher = ({ variant = 'light', className = '', languages = ['sk', 'en', 'tr'] }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const LANGUAGES = ALL_LANGUAGES.filter((l) => languages.includes(l.code));
  const currentCode = (i18n.language || 'sk').split('-')[0];
  const inList = LANGUAGES.find((l) => l.code === currentCode);
  // If current language isn't allowed in this switcher (e.g. TR on public navbar), fall back display to first allowed
  const current = inList || LANGUAGES[0];

  useEffect(() => {
    const onClickOut = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOut);
    return () => document.removeEventListener('mousedown', onClickOut);
  }, []);

  const select = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className={`langsw langsw--${variant} ${className}`} ref={ref}>
      <button
        className="langsw__btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="Change language"
        aria-expanded={open}
      >
        <FaGlobe />
        <span>{current.short}</span>
      </button>
      {open && (
        <ul className="langsw__menu" role="listbox">
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                role="option"
                aria-selected={l.code === current.code}
                onClick={() => select(l.code)}
                className={`langsw__item ${l.code === current.code ? 'langsw__item--active' : ''}`}
              >
                <span className="langsw__short">{l.short}</span>
                <span className="langsw__label">{l.label}</span>
                {l.code === current.code && <FaCheck className="langsw__check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LangSwitcher;
